/**
 * Mailing Balance Service - API client for mailing balance operations
 */

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000'

function getAuthHeaders(): HeadersInit {
  const token = localStorage.getItem('auth_token')
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  }
}

export async function getMailingBalance(): Promise<{ balance: number }> {
  const response = await fetch(`${API_URL}/api/mailing-balance/balance`, {
    headers: getAuthHeaders()
  })
  if (!response.ok) throw new Error('Failed to get mailing balance')
  return response.json()
}

export async function initiateAddBalance(params: {
  amount: number
  saved_payment_method_id?: string
  save_payment_method?: boolean
}): Promise<{ client_secret?: string; payment_intent_id: string; success?: boolean; balance?: number }> {
  const response = await fetch(`${API_URL}/api/mailing-balance/add`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(params)
  })
  if (!response.ok) {
    const data = await response.json()
    throw new Error(data.error || 'Failed to initiate payment')
  }
  return response.json()
}

export async function confirmAddBalance(paymentIntentId: string): Promise<{ success: boolean; balance: number }> {
  const response = await fetch(`${API_URL}/api/mailing-balance/confirm`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ payment_intent_id: paymentIntentId })
  })
  if (!response.ok) {
    const data = await response.json()
    throw new Error(data.error || 'Failed to confirm payment')
  }
  return response.json()
}
